<template>
    <div class="j-image-preview__wrapper">
        <div class="j-image-preview__header" />
        <div class="j-image-preview__mask">
            <div class="j-image-preview__btn j-image-preview__actions">
                <div v-show="previewTitle" class="j-image-preview__name">{{previewTitle}}</div>
                <span v-if="srcList.length > 1" class="j-image-preview__btn j-image-preview__prev" @click="prev"><i class="el-icon-arrow-left"/></span>
                <div class="el-image-viewer__actions__inner">
                    <i class="el-icon-zoom-out" @click="scaleMin(-0.1)"></i>
                    <i class="el-icon-zoom-in" @click="scaleMax(0.1)"></i>
                    <i class="el-icon-full-screen" v-show="!fullscreen" @click="toFullScreen"></i>
                    <i class="el-icon-c-scale-to-original" v-show="fullscreen" @click="toOriginal"></i>
                    <i class="el-icon-refresh-left" @click="rotate(-90)"></i>
                    <i class="el-icon-refresh-right" @click="rotate(90)"></i>
                    <i class="el-icon-circle-close" @click="close"></i>
                </div>
                <span v-if="srcList.length > 1" class="j-image-preview__btn j-image-preview__next" @click="next"><i class="el-icon-arrow-right"/></span>
            </div>
            <div class="j-image-preview__canvas"
                 v-loading="loading"
                 element-loading-text="图片加载中..."
                 element-loading-background="transparent"
            >
                <img ref="img" class="j-image-preview__img" :style="imgStyle" :src="previewSrc" :alt="title || curItem[listProps.title] || ''">
            </div>
        </div>
        <!-- CLOSE -->
<!--        <span class="j-image-preview__btn j-image-preview__close" @click="close"><i class="el-icon-error" /></span>-->
    </div>
</template>

<script>
    export default {
        name: 'JImagePreview',
        props: {
            title: {
                type: String,
                default: ''
            },
            src: {
                type: String,
                default: ''
            },
            index: {
                type: Number,
                default: 0
            },
            srcList: {
              type: Array,
              default: () => []
            },
            listProps: {
                type: Object,
                default: () => ({ src: 'src', title: 'title' })
            }
        },
        computed: {
            imgStyle () {
                return {
                    transform: `scale(${this.scale}) rotate(${this.deg}deg)`,
                    transition: 'transform .3s',
                    maxWidth: this.fullscreen ? '' : '100%',
                    maxHeight: this.fullscreen ? '' : '100%'
                }
            }
        },
        data () {
            return {
                loading: true,
                fullscreen: false,
                scale: 1,
                deg: 0,
                curItem: {},
                previewTitle: '',
                previewSrc: '',
                previewIndex: 0
            }
        },
        created () {
          this.previewSrc = this.src
          if (this.index === 0 || this.index > 0) this.previewIndex = this.index
          this.previewTitle = this.title
          if (this.srcList.length > 0) this.setCurrent()
        },
        mounted () {
            this.$refs.img.onmousewheel = (e) => {
                if (e.wheelDeltaY > 0) {
                    this.scaleMax(0.1)
                } else {
                    this.scaleMin(-0.1)
                }
            }
            this.$refs.img.onload = () => { this.loading = false }
            window.addEventListener('keyup', this.escEvent, false)
        },
        beforeDestroy () {
            window.onmousewheel = null
            window.removeEventListener('keyup', this.escEvent)
        },
        methods: {
            setCurrent () {
                this.curItem = this.srcList[this.previewIndex]
                this.previewSrc = this.curItem[this.listProps.src]
                this.previewTitle = this.curItem[this.listProps.title]
            },
            toFullScreen () {
                this.fullscreen = true
                this.scale = 1.4
            },
            toOriginal () {
                this.fullscreen = false
                this.scale = 1
            },
            prev () {
                if (this.loading) return
                this.loading = true
                if (this.previewIndex === 0) this.previewIndex = this.srcList.length - 1
                else this.previewIndex = this.previewIndex - 1
                this.setCurrent()
            },
            next () {
                if (this.loading) return
                this.loading = true
                if (this.previewIndex === this.srcList.length - 1) this.previewIndex = 0
                else this.previewIndex = this.previewIndex + 1
                this.setCurrent()
            },
            rotate (deg) {
                this.deg += deg
            },
            scaleMin (value) {
                if (this.scale < 0.4) return
                this.scale += value
            },
            scaleMax (value) {
                if (this.scale >= 2) return
                this.scale += value
            },
            close () {
                this.$emit('update:close', false)
                this.remove && this.remove()
            },
            escEvent (e) {
                if (e.which === 27) {
                    this.close()
                }
            }
        }
    }
</script>

<style lang="scss">
    .j-image-preview__wrapper {
        display: flex;
        flex-direction: column;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 9999;
        padding: 14px 20px 8px;
        background: rgba(21,24,30,0.3);
        .j-image-preview__header {
          height: 50px;
            font-size: 16px;
            color: #303133;
            padding: 0 30px 6px 6px;
            overflow:hidden; //超出的文本隐藏
            text-overflow:ellipsis; //溢出用省略号显示
            white-space:nowrap; //溢出不换行
        }
        .j-image-preview__mask {
            flex: 1;
            width: 100%;
            min-height: 100px;
            background: rgba(21,24,30,0.3);
            border-radius: 8px;
            overflow: hidden;
        }
        .j-image-preview__canvas {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .j-image-preview__img {
            transform: scale(1) rotate(0deg);
            margin-left: 0px;
            margin-top: 0px;
        }
        .j-image-preview__btn {
            position: absolute;
            z-index: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            opacity: .8;
            cursor: pointer;
            box-sizing: border-box;
            user-select: none;
        }
        .j-image-preview__close{
            top: 8px;
            right: 8px;
            width: 40px;
            height: 24px;
            font-size: 24px;
            color: #fff;
            z-index: 9999;
        }
        .j-image-preview__prev {
            top: 50%;
            width: 32px;
            height: 32px;
            font-size: 24px;
            color: #fff;
            background-color: #606266;
            border-color: #fff;
            transform: translateY(-50%);
            left: -48px;
        }
        .j-image-preview__next {
            top: 50%;
            width: 32px;
            height: 32px;
            font-size: 24px;
            color: #fff;
            background-color: #606266;
            border-color: #fff;
            transform: translateY(-50%);
            right: -48px;
            text-indent: 2px;
        }
        .j-image-preview__actions {
            left: 50%;
            bottom: 30px;
            transform: translateX(-50%);
            width: 282px;
            height: 44px;
            padding: 0 23px;
            background-color: #606266;
            border-color: #fff;
            border-radius: 22px;
            .j-image-preview__name {
              position: absolute;
              bottom: 60px;
              color: #fff;
              background-color: #606266;
              border-radius: 6px;
              padding: 5px 10px;
              text-align: center;
            }
        }
        .el-image-viewer__actions__inner {
            i {
                cursor: pointer;
            }
        }
    }
</style>
